// home page 
import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import ImageWithBasePath from '../../core/common/imageWithBasePath'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import SearchBy from './searchBy';
import SectionBenefit from './sectionBenefit';
import PlaceSections from './placeSection';
import AboutSection from './about-section';
import ExpertSection from './experts-section';
import TestimonialSection from './testimonialSection';
import UpdateSection from './updateSection';
import AOS from 'aos';
import 'aos/dist/aos.css';
import FlightSearchForm from './components/flightSearchForm/FlightSearchForm';
import HotelSearchForm from './components/hotelSearchForm/HotelSearchForm';

import { useSelector } from "react-redux";
import { RootState } from "../../core/redux/store";

const HomeOne = () => {
  const user = useSelector((state: RootState) => state.auth.user);
  const location = useLocation();

  const [activeTab, setActiveTab] = useState<"flight" | "hotel">("flight");
  // console.log("Current User in HomeOne:", user);
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    arrows: false,
  };

  AOS.init();
  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init({
      duration: 1000,
    });
  }, []);
  const handleScroll = () => {
    AOS.refresh();
  };

  useEffect(() => {
    if (location.hash === "#flights") {
      setActiveTab("flight");
    } else if (location.hash === "#hotels") {
      setActiveTab("hotel");
    }

    if (location.hash === "#flights" || location.hash === "#hotels") {
      const hero = document.querySelector(".hero-section");
      if (hero) {
        hero.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [location.hash]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      {/* Hero Section */}
      <section className="hero-section">
        <Slider {...settings} className="banner-slider banner-sec owl-carousel">
          <div className="slider-img">
            <ImageWithBasePath src="assets/img/banner/banner-01.jpg" alt="Img" />
          </div>
        </Slider>
        <div className="container">
          <div className="hero-content">
            <div className="row align-items-center">
              <div className="col-md-12 mx-auto aos fadeInUp" data-aos="fade-up">
                <div className="banner-content mx-auto">
                  <h1 className="text-white display-5 mb-2">
                    Trio <span>Your Partner in Crafted Travel Experiences.</span>
                  </h1>
                </div>
                <div className="banner-form card mb-0">
                  <div className="card-header">
                    <ul className="nav">
                      <li>
                        <button
                          type="button"
                          className={`nav-link ${activeTab === "flight" ? "active" : ""}`}
                          onClick={() => setActiveTab("flight")}
                        >
                          <i className="isax isax-airplane5 me-2" />
                          Flights
                        </button>
                      </li>
                      <li>
                        <button
                          type="button"
                          className={`nav-link ${activeTab === "hotel" ? "active" : ""}`}
                          onClick={() => setActiveTab("hotel")}
                        >
                          <i className="isax isax-buildings5 me-2" />
                          Hotels
                        </button>
                      </li>
                    </ul>
                  </div>
                  <div className="card-body">
                    <div className="tab-content">
                      <div
                        className={`tab-pane fade ${activeTab === "flight" ? "active show" : ""
                          }`}
                        id="flight"
                      >
                        <FlightSearchForm />
                      </div>
                      <div
                        className={`tab-pane fade ${activeTab === "hotel" ? "active show" : ""
                          }`}
                        id="Hotels"
                      >
                        <HotelSearchForm />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* /Hero Section */}
      <SearchBy />
      <SectionBenefit />
      {/* <PlaceSections /> */}
      {/* <AboutSection /> */}
      {/* <ExpertSection /> */}
      {/* <TestimonialSection /> */}
      <UpdateSection />
    </>

  )
}

export default HomeOne